import LOGO from "../images/cerveceros.png";

export const Team__Cerveceros_MAIN = {
  name: "Cerveceros",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#3d0003",
  teamJerseyColor: "#E6DE0B",

  // Stats
  gamesWon: 2,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 38 + 36 + 53,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 55 + 41 + 47,
    },
  ],
};
